/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the hook used to retrieve the Theme Manager Context.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Enables the use of category data loaded from the ServiceStack API.
 */
import { TermsSelectors, useTermsSelector } from 'src/store/reducers/terms';

/**
 * Typings
 */
import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const useTermsIndividual = (
    categoryId: number | null,
    termId: number,
    subtermId: number | null
): [
    Dtos.Term | null
] => {
    const type = subtermId ? 'byTerm' : 'byCategory';
    const primaryId = subtermId ? termId : categoryId;
    const secondaryId = subtermId ? subtermId : termId;

    const term = useTermsSelector(state => primaryId && secondaryId ? TermsSelectors[type].selectTerm(state, primaryId, secondaryId) : null);

    return [
        term
    ];
};

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default useTermsIndividual;


// WEBPACK FOOTER //
// ./src/hooks/useTermsIndividual.ts